import React, { useState } from 'react';
import './Pay.css';
import logo from '../../img/logo_uam.png'
import wave from '../../img/wave.jpg'
import om from '../../img/OM.jpg'
import axios from 'axios';
import freemoney from '../../img/free-money.jpg'
import expresso from '../../img/expresso.jpg'
import bank from'../../img/carte-bancaire-50px.svg'
import { Image, Form,Container,Button,Spinner } from 'react-bootstrap';
import IdTransaction from '../../components/idTransaction/IdTransaction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faL } from "@fortawesome/free-solid-svg-icons";
import AlerteMessage from '../../components/AlerteMessage';
import { useEffect } from 'react';
import { DateRange } from '@mui/icons-material';
import Env from '../../hooks/Env';

function PayUniforme ({infos}) {
    const {API_URL,ANNEE_UNIVERSITE} = Env() ;
    console.log("Infos dans PayUniforme", infos)

    // Initialiser data avec les valeurs de infos si disponibles
    const [data, setData] = useState(() => {
        if (infos && Object.keys(infos).length > 0) {
            console.log("Infos dans PayUniforme useState", infos)
            return {
                campagne: infos?.codePermanent ?'reinscription' : 'cepec',
                codePermanent: infos.codePermanent || '',
                email: infos.email || '',
                // annee_universitaire: infos.annee_universitaire || ''
            };
        }
        return {};
    });
    const [show, setShow] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [checked, SetChecked] = useState(false);
    const [open, setOpen] = useState (false);
    const [message, setMessage] = useState (false);
    const [auth, setAuth] = useState(true);
    const [admisInfos, setAdmisInfos] = useState(null);
    const [anneeActive, setAnneeActive] = useState(ANNEE_UNIVERSITE);

    useEffect(() => {
        axios.get(`${API_URL}/annee_universitaire/active`)
            .then(result => {
                if (result.data?.libelle) setAnneeActive(result.data.libelle);
            })
            .catch(() => {});
    }, [API_URL]);
    const [valid, SetIsValid] = useState({
        isValidEmail: false,
        isValidPhoneNumber: false,
      });
    const handleChange = (e) => {
        const name= e.target.name;
        const value = e.target.value;
        console.log(name,value)
        
        setData((prevData) => ({ ...prevData, [name]: value }));
        
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{1,9}$/; 
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            SetIsValid((valid) => ({
                ...valid,
                isValidEmail: emailRegex.test(value),
            }));
        }
        if (name === 'operateur') {
            SetChecked(e.target.checked)
        }
    }
    const handleClose3 = () => {
        setOpen(false)
    }
    let NotComplete = true;
    if (data.campagne === 'admission' || data.campagne === 'concours') {
        if (!valid.isValidEmail || !valid.isValidPhoneNumber || !checked || !data.campagne) {
            NotComplete = false;
        }
    } else if (data.campagne === 'inscription') {
        if (!data.codePermanent || !valid.isValidPhoneNumber || !checked) {
            NotComplete = false;
        }
    } else {
        if (!data.campagne || !valid.isValidPhoneNumber || !checked || (!data.codePermanent && data.campagne !== 'cepec')) {
            NotComplete = false;
        }
    }
    const showCode = (data.campagne === 'reinscription') || (!Boolean(infos?.codePermanent) && data.campagne !== 'cepec' && data.campagne !== 'inscription');
    const lancerPaiement = (dataPayload) => {
        // if (!dataPayload.annee_universitaire) {
        //     dataPayload.annee_universitaire = ANNEE_UNIVERSITE;
        // }
        axios({
            url: `${API_URL}/paiement/`,
            method: 'POST',
            data: dataPayload
        })
        .then(result => {
            console.log('Data from API :', result.data);
            if (result.data.message === 'OK') {
                setSubmitted(false);
                setShow(true);
                if (result.data.paymentURL) {
                    window.location.href = result.data.paymentURL;
                }
            } else if (result.data.detail) {
                setSubmitted(false);
                setMessage(result.data.detail);
                setOpen(true);
            }
        })
        .catch((error) => {
            setSubmitted(false);
            const detail = error?.response?.data?.detail;
            setOpen(true);
            setMessage(detail || 'Impossible d\'initier un paiement');
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        console.log("testing ...")
        console.log(data)

        // Inscription des admis du concours : on vérifie d'abord que le candidat est
        // en liste principale, puis on initie le paiement (année universitaire active).
        if (data.campagne === 'inscription') {
            const codePermanent = String(data.codePermanent).trim();
            axios.get(`${API_URL}/paiement/inscription/admis/${encodeURIComponent(codePermanent)}`)
            .then(response => {
                const result = response.data;
                if (result.detail || !result.admis) {
                    setSubmitted(false);
                    setOpen(true);
                    setMessage(result.detail || 'Vous n\'êtes pas autorisé(e) à vous inscrire pour le moment');
                    return;
                }
                if (result.deja_inscrit) {
                    setSubmitted(false);
                    setOpen(true);
                    setMessage('Votre inscription est déjà enregistrée. Aucun nouveau paiement n\'est nécessaire.');
                    return;
                }
                setAdmisInfos(result);
                lancerPaiement({
                    campagne: 'inscription',
                    codePermanent,
                    telephone: data.telephone,
                    operateur: data.operateur,
                });
            })
            .catch(() => {
                setSubmitted(false);
                setOpen(true);
                setMessage('Impossible de vérifier votre admission');
            });
            return;
        }

        var url
        if (data.campagne ==='uniforme' || data.campagne ==='reinscriptions' || data.campagne ==='master') {
            if (data.campagne ==='reinscriptions' || data.campagne ==='master') {
                url = `${API_URL}/v1/reinscription/confirmed/?codePermanent=${data.codePermanent}`
                console.log("URL reinscription", url)
            } else {
                if (data.campagne ==='uniforme') {
                    url = `${API_URL}/uniforme/confirmed?codePermanent=${data.codePermanent}`
                }
                console.log("URL uniforme", url)
            }
            fetch(url)
            .then(response => {
                if (!response.ok) {
                throw new Error(`Erreur HTTP! Statut: ${response.status}`);
                }
                return response.json();
            })
            .then(result => {
                console.log(result)
                if (result.detail) {
                    if (result.detail ==='Votre dossier n\'as pas été enregistré') {
                        setMessage('Vous n\'etes pas autorisés à payer')
                        setSubmitted(false);
                        setOpen(true)
                        // return
                    } else{
                        setMessage(result.detail)
                    }
                    setSubmitted(false);
                    setOpen(true)
                    return
                }
                if (result.data.email){
                    // data['email'] = result?.mail_ins
                    console.log(result.data.email)
                    data['email'] = result?.data.email
                    axios({
                        url:`${API_URL}/paiement/`,
                        method: 'POST',
                        data:data
                    })
                    .then(result => {
                        console.log("Initialisation Success");
                        console.log('Data from API :', result.data);
                        if (result.data.message==='OK') {
                            console.log(result.data)
                            setSubmitted(false);
                            setShow(true);
                            if (result.data.paymentURL) {
                                window.location.href = result.data.paymentURL;
                            //    window.open(result.data.paymentURL, "_blank");
                            }
                        }
                        //window.location.href = result.data.paymentURL;
                    })
                    .catch((error) => {
                        setSubmitted(false);
                        if (error.response.status === '500') {
                            console.log(error.response.data)
                            setOpen(true)
                            setMessage('Impossible d\'initier un paiement ')
                        } else {
                            if (error.response.data.detail) {
                                setOpen(true)
                                setMessage(error.response.data.detail)
                            }
                        }
                        // console.error('Error:', error);
                        setSubmitted(false);
                    });
                } else if (result.detail) {
                    setSubmitted(false);
                    setMessage('Impossible d\'initier un paiement ')
                    setOpen(true)
                }
                
            })
            .catch(error => {
                setSubmitted(false);
                console.error('Erreur lors de la requête:', error);
                setMessage('Impossible d\'initier un paiement ')
                setOpen(true)
            });
        } else {
        //    if (!data.annee_universitaire) {
        //     data.annee_universitaire = ANNEE_UNIVERSITE
        //    }
            axios({
                url:`${API_URL}/paiement/`,
                method: 'POST',
                data:data
                    })
                    .then(result => {
                        console.log("Initialisation Success");
                        console.log('Data from API :', result.data);
                        if (result.data.message==='OK') {
                            console.log(result.data)
                            setSubmitted(false);
                            setShow(true);
                            if (result.data.paymentURL) {
                                window.location.href = result.data.paymentURL;
                            //    window.open(result.data.paymentURL, "_blank");
                            }
                        }else if (result.data.detail) {
                            setSubmitted(false);
                            setMessage(result.data.detail) ;
                            setOpen(true) ;
                        }
                        //window.location.href = result.data.paymentURL;
                    })
                    .catch((error) => {
                        setSubmitted(false);
                        if (error.response.status === '500') {
                            console.log(error.response.data)
                            setOpen(true)
                            setMessage('Impossible d\'initier un paiement ')
                        } else {
                            if (error.response.data.detail) {
                                setOpen(true)
                                setMessage(error.response.data.detail)
                            }
                        }
                        // console.error('Error:', error);
                        setSubmitted(false);
                    });
        }
    }
    return (
        <>
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        <IdTransaction show={show} email={data.email} handleClose={() => 
            {setShow(false)}
            } />
        <Container className='pay' id='main'>
            <div className='d-flex flex-row' id='payHead'>
                <div>
                    <Image src={logo} width={239} height={220} />
                </div>
                <div className='' id='texthead'>
                    <p>Université Amadou Mahtar Mbow </p>
                    <p>Année Académique {anneeActive}</p>
                </div>
            </div>
            <div>
                <Form onSubmit={handleSubmit} className=''>
                    <div className='p-4 row'>
                        {auth ? 
                        <>
                            <Form.Group className='col-md-8 col-sm-12'>
                                <Form.Label>Campagne</Form.Label>
                                <Form.Select name='campagne' value={data.campagne || ''} onChange={handleChange} disabled={infos && Object.keys(infos).length > 0}>
                                    <option value="">Veuiller selectionner une campagne de paiement</option>
                                    <option value="uniforme">Uniforme</option>
                                    <option value="inscription">Inscription (admis au concours)</option>
                                    <option disabled={infos && Object.keys(infos).length > 0 ? false : true} value="reinscription">Réinscription</option>
                                    {/* <option value="master">Inscription Master</option> */}
                                    {/* <option disabled value="concours">Concours</option> */}
                                    <option disabled={infos && Object.keys(infos).length > 0 ? false : true} value="cepec">CEPEC</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className='col-md-6 col-sm-12 mb-3'>
                                <Form.Label>Téléphone</Form.Label>
                                <Form.Control 
                                    placeholder='XXXXXXXXX'
                                    size='md'
                                    type='number'
                                    name='telephone'
                                    className='p-2 custom-email-input'
                                    onChange={handleChange}
                                    autoFocus
                                    required
                                />
                            </Form.Group>
                            {data.campagne === 'inscription' ? (
                                <>
                                    <Form.Group className='col-md-6 col-sm-12 mb-3'>
                                        <Form.Label>Numéro de la table BAC</Form.Label>
                                        <Form.Control
                                            placeholder='numéro table BAC'
                                            size='md'
                                            type='text'
                                            name='codePermanent'
                                            value={data.codePermanent || ''}
                                            className='p-2 custom-email-input'
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>
                                    <div className='col-12'>
                                        <p className='text-muted' style={{fontSize:13}}>
                                            Réservé aux candidats admis au concours et autorisés à s'inscrire. Entrez le numéro de table BAC utilisé lors de votre dépôt de candidature : votre admission sera vérifiée avant le paiement.
                                        </p>
                                    </div>
                                </>
                            ) : data.campagne === 'admission' ? (
                                <>
                                    <Form.Group className='col-md-6 col-sm-12 mb-3'>
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        placeholder='Email'
                                        size='md'
                                        type='email'
                                        name='email'
                                        value={data.email || ''}
                                        className='p-2 custom-email-input'
                                        onChange={handleChange}
                                        readOnly={infos && Object.keys(infos).length > 0 && data.campagne==='reinscription'}
                                        required
                                    />
                                    </Form.Group>
                                </>
                            ) : (
                                <>
                                { showCode ? (
                                    <Form.Group className='col-md-6 col-sm-12'>
                                        <Form.Label>Code Permanent</Form.Label>
                                        <Form.Control
                                            placeholder='Code Permanent'
                                            size='md'
                                            type='text'
                                            name='codePermanent'
                                            value={data.codePermanent || ''}
                                            className='p-2 custom-email-input'
                                            onChange={handleChange}
                                            autoFocus
                                            required
                                        />
                                    </Form.Group>
                                ) : null }
                                </>
                            )} 
                            
                            <Form.Group>
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="operateur"
                                    value="wave"
                                    label = {
                                        <Image src={wave} height={80} width={80} alt="wave" />
                                    }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="operateur"
                                    value="orange-money"
                                    label = {
                                        <Image src={om} height={80} width={80} alt="wave" />
                                    }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="operateur"
                                    value="free-money"
                                    label = {
                                        <Image src={freemoney} height={80} width={80} alt="wave" />
                                    }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="operateur"
                                    value="e-money"
                                    label = {
                                        <Image src={expresso} height={80} width={80} alt="wave" />
                                    }
                                />
                                {/* <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="operateur"
                                    value="mobilebank"
                                    label = {
                                        <Image src={bank} height={80} width={80} alt="cartebancaire" />
                                    }
                                /> */}
                            </Form.Group>
                            {data.campagne === 'uniforme' && (
                                <div>
                                    <p className='text-danger ml-2' id='frais'>Le paiement des droits d'inscription, non remboursables, sont de vingt mille (20 000) F. CFA + frais de 250 F. CFA</p>
                                </div>
                            )}
                            {data.campagne === 'master' && (
                                <div>
                                    <p className='text-danger ml-2' id='frais'>Le paiement des droits d'inscription, non remboursables, sont de cinquante milles (50 000) F. CFA + frais de 625 F. CFA</p>
                                </div>
                            )}
                            {data.campagne === 'reinscription' && (
                                <div>
                                    <p className='text-danger ml-2' id='frais'>Le paiement des droits d'inscription, non remboursables, sont de vingt cinq milles (25 000) F. CFA + frais de 315 F. CFA</p>
                                </div>
                            )}
                            {data.campagne === 'inscription' && admisInfos && (
                                <div>
                                    <p className='text-danger ml-2' id='frais'>
                                        {admisInfos.prenom} {admisInfos.nom}{admisInfos.filiere ? ` - ${admisInfos.filiere}` : ''}<br />
                                        Frais d'inscription : <strong>{Number(admisInfos.montant).toLocaleString('fr-FR')} F. CFA</strong>
                                    </p>
                                </div>
                            )}
                        </>
                        : 
                        <>
                            <Form.Group className='col-md-6 col-sm-12'>
                                <Form.Label>Numéro de Table BAC</Form.Label>
                                <Form.Control 
                                    placeholder='501577'
                                    size='md'
                                    type='number'
                                    name='codePermanent'
                                    className='p-2 custom-email-input'
                                    onChange={handleChange}
                                    autoFocus
                                    required
                                />
                            </Form.Group>
                            <Form.Group className='col-md-6 col-sm-12'>
                                <Form.Label>Campagne</Form.Label>
                                <Form.Select name='campagne'>
                                    <option value="uniforme">Uniforme</option>
                                    <option value="inscription">Inscription (Admis par dossier)</option>
                                    <option disabled value="reinscription">Réinscription</option>
                                    <option disabled value="concours">Concours</option>
                                    <option disabled value="admission">Admission</option>
                                </Form.Select>
                            </Form.Group>
                        </>
                        }
                    </div>
                    
                   
		
		{/* <input onClick={callTouchPay} className='intouch' type='button'  value='Payer avec carte'/> */}

                    <Button
                        onClick={data.operateur === 'mobilebank' ? 'callTouchPay' : handleSubmit}
                        variant='primary' 
                        disabled={!NotComplete} type='button'
                        className ='w-75 btn-submit'
                        >
                            {NotComplete ? (<span>Payer avec {data.operateur}</span>)  : <FontAwesomeIcon icon={faBan} className='color-logo' />} 
                            {submitted ? 
                                <Spinner animation="grow"
                                    size="sm" role="status"
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner> 
                            : null} 
                    </Button>
                </Form>
            </div>
        </Container>
        </>
    )
}
export default PayUniforme